import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// The root element is defined in public/index.html.  We create a React
// root and render our application into it.  This entry point mirrors
// create-react-app defaults but uses the modern createRoot API introduced
// in React 18.
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);